export const addToFavoritesCategoryText = "s_0P9c";
export default {addToFavoritesCategoryText};